import React, { useEffect, useState } from 'react'
import skilldata from './skills.json'
//import $ from 'jquery';

function Skills() {
    //toggling icon
    let [ico, upico] = useState("fas fa-caret-down");
    let [ico2, upico2] = useState("fas fa-caret-down");
    let [nightToggle, upnightToggle] = useState(false);

    let frontend = skilldata.filter(data => data.type === "frontend");
    let backend = skilldata.filter(data => data.type === "backend");
    //icon changing code
    useEffect(() => {
        document.querySelector('#ch').addEventListener('click', () => {
            if (document.querySelector('#ch').checked === true) {
                upico("fa fa-angle-up");
                if (frontend.length > 3)
                    document.querySelector('#scrl').style.display = "block";
            }
            else {
                upico("fas fa-caret-down");
                if (frontend.length > 3)
                    document.querySelector('#scrl').style.display = "none";
            }
        })
        document.querySelector('#chb').addEventListener('click', () => {
            if (document.querySelector('#chb').checked === true) {
                upico2("fa fa-angle-up");
                if (backend.length > 3)
                    document.querySelector('#scrl2').style.display = "block";
            }
            else {
                upico2("fas fa-caret-down");
                if (backend.length > 3)
                    document.querySelector('#scrl2').style.display = "none";
            }
        })

    }, [])

    useEffect(() => {
        //navbar code
        document.querySelector('#nmode_').addEventListener('click', () => {//if button clicked of navbar
            if (document.querySelector('#night_mode').checked === false) {
                upnightToggle(false);
            }
            else {
                upnightToggle(true);
            }
        })
        document.querySelector('.switch').addEventListener('click', () => {//for responsive check button
            if (document.querySelector('#night_mode').checked === false) {
                upnightToggle(false);
            }
            else {
                upnightToggle(true);
            }
        })
        //Skills page body code
        if (document.querySelector('body').classList.contains('nightbackground') === false) {//on arriving of page
            upnightToggle(false);
        }
        else {
            upnightToggle(true);
        }
        if (!nightToggle) {
            document.querySelector('.barbox1').classList.replace('bg-dark', 'bg-light');
            document.querySelector('.barbox1').classList.replace('text-light', 'text-dark');
            document.querySelector('.barbox2').classList.replace('bg-dark', 'bg-light');
            document.querySelector('.barbox2').classList.replace('text-light', 'text-dark');
        }
        else {
            document.querySelector('.barbox1').classList.replace('bg-light', 'bg-dark');
            document.querySelector('.barbox1').classList.replace('text-dark', 'text-light');
            document.querySelector('.barbox2').classList.replace('bg-light', 'bg-dark');
            document.querySelector('.barbox2').classList.replace('text-dark', 'text-light');
        }
    }, [nightToggle])
    return (
        <>
            <div className="row mt-5">
                <div className="col text-center">
                    <p className="h2">Skills</p>
                    <p className="text-primary">My Technical Level</p>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-sm-6">
                    <div className="row p-2 position-relative">
                        <div className="front_end_div">
                            <i className="fas fa-paint-brush" style={{ fontSize: "100%" }}></i>
                            <div className="t">
                                <h4>Frontend skills</h4>
                                <small className="text-muted">Fresher</small>
                            </div>
                            {frontend.length > 3 ?//frontend list is greator than 3 then show scroll down icon
                                <img title="Scroll down" id="scrl" src="https://cdn-icons-png.flaticon.com/512/1432/1432631.png" alt="Scroll down" />
                                : null}
                            <label htmlFor="ch"><i className={ico}></i></label>
                        </div>
                        <input type="checkbox" id="ch" hidden />
                        <div className="barbox1 bg-light text-dark border p-2">
                            {
                                frontend.map((data) => {
                                    return (
                                        <>
                                            <div className="bars">
                                                <div className="skill clearfix">
                                                    <p className="float-left">{data.technology}</p>
                                                    <p className="float-right">{data.progress}</p>
                                                </div>
                                                <div className="meter">
                                                    <div className="fill" style={{ animation: "anim2 1.5s ease normal", width: data.progress }}>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>

                    </div>
                </div>
                <div className="col-sm-6 ">
                    <div className="row p-2">
                        <div className="back_end_div ">
                            <i className='fas fa-code' style={{ fontSize: "100%" }}></i>
                            <div className="t">
                                <h4>Backend skills</h4>
                                <small className="text-muted">Fresher</small>
                            </div>
                            {backend.length > 3 ?//frontend list is greator than 3 then show scroll down icon
                                <img title="Scroll down" id="scrl2" src="https://cdn-icons-png.flaticon.com/512/1432/1432631.png" alt="Scroll down" />
                                : null}
                            <label htmlFor="chb"><i className={ico2}></i></label>
                        </div>
                        <input type="checkbox" id="chb" hidden />
                        <div className="barbox2 bg-light text-dark border p-2">
                            {
                                backend.map((data) => {
                                    return (
                                        <>
                                            <div className="bars ">
                                                <div className="skill clearfix">
                                                    <p className="float-left">{data.technology}</p>
                                                    <p className="float-right">{data.progress}</p>
                                                </div>
                                                <div className="meter">
                                                    <div className="fill" style={{ animation: "anim2 1.5s ease normal", width: data.progress }}></div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Skills
